export const LOAD_PACKAGING = 'LOAD_PACKAGING';
export const CLOSE_ORDER_ITEM = 'CLOSE_ORDER_ITEM';
export const SET_PACKAGING_FILTERS = 'SET_PACKAGING_FILTERS';
export const RESET_PACKAGING_FILTERS = 'RESET_PACKAGING_FILTERS';
export const SET_PACKAGING_PAGINATION = 'SET_PACKAGING_PAGINATION';
export const SET_PACKAGING_IS_CLOSED = 'SET_PACKAGING_IS_CLOSED';
export const SET_PACKAGING_SORT = 'SET_PACKAGING_SORT';
